module.exports = __webpack_public_path__ + "img/guessList.5760636a.svg";